require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// ./~/angular-route/index.js
// module id = 37
// module chunks = 12 13 21 22 25 26